import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_ef1cd3b4 from 'nuxt_plugin_plugin_ef1cd3b4' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_000e337c from 'nuxt_plugin_cookieuniversalnuxt_000e337c' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_metaplugin_3d15e303 from 'nuxt_plugin_metaplugin_3d15e303' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_41bd8877 from 'nuxt_plugin_iconplugin_41bd8877' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_35828858 from 'nuxt_plugin_axios_35828858' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_router_76e54a5b from 'nuxt_plugin_router_76e54a5b' // Source: ./router.js (mode: 'all')
import nuxt_plugin_detectDomain_1ddc8886 from 'nuxt_plugin_detectDomain_1ddc8886' // Source: ../plugins/detectDomain (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_directives_d0867c0c from 'nuxt_plugin_directives_d0867c0c' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_fontawesome_47952b5b from 'nuxt_plugin_fontawesome_47952b5b' // Source: ../plugins/font-awesome (mode: 'all')
import nuxt_plugin_google_6cb9a52c from 'nuxt_plugin_google_6cb9a52c' // Source: ../plugins/google.client (mode: 'client')
import nuxt_plugin_gtag_f73fb9e0 from 'nuxt_plugin_gtag_f73fb9e0' // Source: ../plugins/gtag.client (mode: 'client')
import nuxt_plugin_lazyload_7cd228ae from 'nuxt_plugin_lazyload_7cd228ae' // Source: ../plugins/lazyload.client (mode: 'client')
import nuxt_plugin_logger_52e3bef4 from 'nuxt_plugin_logger_52e3bef4' // Source: ../plugins/logger (mode: 'all')
import nuxt_plugin_noty_201b357d from 'nuxt_plugin_noty_201b357d' // Source: ../plugins/noty.client (mode: 'client')
import nuxt_plugin_persistedState_1da7f7d4 from 'nuxt_plugin_persistedState_1da7f7d4' // Source: ../plugins/persistedState (mode: 'all')
import nuxt_plugin_tooltip_f7e3b5e8 from 'nuxt_plugin_tooltip_f7e3b5e8' // Source: ../plugins/tooltip.client (mode: 'client')
import nuxt_plugin_tracking_0c9c98ac from 'nuxt_plugin_tracking_0c9c98ac' // Source: ../plugins/tracking.client (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_whitelabel_cb18b73e from 'nuxt_plugin_whitelabel_cb18b73e' // Source: ../plugins/whitelabel (mode: 'all')
import nuxt_plugin_meta_3df4c2b8 from 'nuxt_plugin_meta_3df4c2b8' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Rahalaitos","htmlAttrs":{"lang":"fi"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Rahalaitos tekee yhteistyötä monien pankkien ja\n          rahoituslaitoksien kanssa ja näin pyrimme aina hankkimaan sinulle\n          edullisimman lainan parhailla mahdollisilla ehdoilla. Saat kauttamme\n          lainan nopeammin, edullisimmin ja helpoimmin. Täytä hakemus ilmaiseksi\n          jo tänään!"},{"name":"msapplication-TileColor","content":"#2a404b"},{"name":"theme-color","content":"#2a404b"},{"name":"author","content":"Rahalaitos Oy"}],"script":[{"id":"Cookiebot","src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js","data-cbid":"a6dc036a-6f36-4585-a900-39524e78a8d3","data-blockingmode":"auto"},{"hid":"hotjar","innerHTML":"(function(h,o,t,j,a,r){\n            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n            h._hjSettings={hjid:5113004,hjsv:6};\n            a=o.getElementsByTagName('head')[0];\n            r=o.createElement('script');r.async=1;\n            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n            a.appendChild(r);\n        })(window,document,'https:\u002F\u002Fstatic.hotjar.com\u002Fc\u002Fhotjar-','.js?sv=');"}],"__dangerouslyDisableSanitizersByTagID":{"hotjar":["innerHTML"]},"link":[{"rel":"preconnect","href":"https:\u002F\u002Fbat.bing.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fconnect.facebook.net","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fgoogleads.g.doubleclick.net","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fservice.giosg.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fsessions.bugsnag.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Ftrack.adform.net","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googleadservices.com","crossorigin":"anonymous"},{"rel":"preload","href":"\u002Ffonts\u002FCoreSansC-45Regular.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","href":"\u002Ffonts\u002FCoreSansC-65Bold.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","href":"\u002Ffonts\u002FCoreSansC-75ExtraBold.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":"anonymous"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_ef1cd3b4 === 'function') {
    await nuxt_plugin_plugin_ef1cd3b4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_000e337c === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_000e337c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_3d15e303 === 'function') {
    await nuxt_plugin_metaplugin_3d15e303(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_41bd8877 === 'function') {
    await nuxt_plugin_iconplugin_41bd8877(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_35828858 === 'function') {
    await nuxt_plugin_axios_35828858(app.context, inject)
  }

  if (typeof nuxt_plugin_router_76e54a5b === 'function') {
    await nuxt_plugin_router_76e54a5b(app.context, inject)
  }

  if (typeof nuxt_plugin_detectDomain_1ddc8886 === 'function') {
    await nuxt_plugin_detectDomain_1ddc8886(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_d0867c0c === 'function') {
    await nuxt_plugin_directives_d0867c0c(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_47952b5b === 'function') {
    await nuxt_plugin_fontawesome_47952b5b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_google_6cb9a52c === 'function') {
    await nuxt_plugin_google_6cb9a52c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_f73fb9e0 === 'function') {
    await nuxt_plugin_gtag_f73fb9e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyload_7cd228ae === 'function') {
    await nuxt_plugin_lazyload_7cd228ae(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_52e3bef4 === 'function') {
    await nuxt_plugin_logger_52e3bef4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_noty_201b357d === 'function') {
    await nuxt_plugin_noty_201b357d(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedState_1da7f7d4 === 'function') {
    await nuxt_plugin_persistedState_1da7f7d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tooltip_f7e3b5e8 === 'function') {
    await nuxt_plugin_tooltip_f7e3b5e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_0c9c98ac === 'function') {
    await nuxt_plugin_tracking_0c9c98ac(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_whitelabel_cb18b73e === 'function') {
    await nuxt_plugin_whitelabel_cb18b73e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_3df4c2b8 === 'function') {
    await nuxt_plugin_meta_3df4c2b8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
